import React from 'react';
import { Alert } from 'reactstrap';
import { Row, Col, Button, Form, Input } from 'antd';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';

import { connect } from 'react-redux';
import { compose } from 'redux';

import { selectIsLoading, selectErrors, selectHasErrors } from 'containers/App/selectors';
import { sendRequestApiKey } from 'containers/App/actions';
import messages from './messages';

class FormApiKey extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      alertIsVisible: false,
    };
  }

  handleSubmit = e => {
    e.preventDefault();

    if (!this.props.profile.apiKey || this.props.profile.apiKey === ''
      || confirm('Creando una nuova chiave quella attuale verrà disabilitata. Sicuro di voler procedere?')
    ) {
      this.alertDismiss();
      this.props.sendRequestApiKey();
    }
  };

  alertDismiss = () => {
    this.setState({ alertIsVisible: false });
  };

  onCopyButton = () => {
    navigator.clipboard.writeText(this.props.profile.apiKey)
    this.setState({ copied: true }, () => {
      setTimeout(() => this.setState({ copied: false }), 1300)
    });
  };

  render() {
    let { copied, alertIsVisible } = this.state;
    const { hasErrors, isLoading, errors } = this.props;
    const apikeyHasErrors = hasErrors('apiKey')
    let errorMessage;

    if (errors && errors.apiKey && Object.keys(errors.apiKey).length > 0) {
      errorMessage = 'Si sono verificati errori, si prega di riprovare';
    }

    return (
      <div id="ApiKeyForm" className="mt-4">
        {alertIsVisible || apikeyHasErrors ?
          <Alert
            showIcon
            closable
            type={apikeyHasErrors ? 'error' : 'success'}
            afterClose={this.onAlertDismiss}
            message={errorMessage}
            className="mb-3"
          />
          : null
        }
        <div className="form-content">
          <Form layout="vertical">
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  label={
                    <>Chiave API personale (<a href="https://api.ideal-rent.com/docs/index" aria-label={'Documentazione API'}>documentazione <i className="os-icon os-icon-external-link" /></a>)</>
                  }
                  help={copied ? `Copiata 👍🏼` : null}
                  validateStatus={errors.password ? 'error' : null}
                >
                  <Input.Group compact>
                    <Input
                      style={{width: "50%"}}
                      name="api-key"
                      disabled
                      value={this.props.profile.apiKey}
                    />
                    <Button title="Copia" onClick={this.onCopyButton}>
                      <i className={'fa fa-copy icon'}/>
                    </Button>
                  </Input.Group>
                </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Button
                type="primary"
                className="float-right"
                onClick={this.handleSubmit}
                disabled={isLoading}
              >
                <FormattedMessage {...messages.requestNewApiKey} />
              </Button>
            </Col>
          </Row>
          </Form>
        </div>
      </div>
    );
  }
}

export function mapDispatchToProps(dispatch) {
  return {
    sendRequestApiKey: () => dispatch(sendRequestApiKey()),
  };
}

const mapStateToProps = createStructuredSelector({
  isLoading: selectIsLoading(),
  errors: selectErrors(),
  hasErrors: (state, errorDomain) => selectHasErrors(state, errorDomain),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(withConnect)(FormApiKey);
